import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Box, ButtonBase, IconButton, Typography, type SxProps } from '@mui/material';
import { Center, flatSx, FlexRow } from '@ocodelib/mui';
import { sxAbsolute } from '@repo-foundation/util/sx-util';
import clsx from 'clsx';
import type React from 'react';
import { toast } from 'react-toastify';

interface Props {
  sx?: SxProps;
  className?: string;
  title: React.ReactNode;
  desc: React.ReactNode;
  imgUrl: string;
  onClick?: React.MouseEventHandler;
}

export function AiLearnListRow(props: Props) {
  return (
    <>
      {/* <MdOrUp>
        <ListRow {...props} />
      </MdOrUp>
      <SmOrDown>
        <GridRow {...props} />
      </SmOrDown> */}
      <GridRow {...props} />
    </>
  );
}

function ListRow(props: Props) {
  const { sx, className, title, desc, imgUrl, onClick } = props;

  return (
    <ButtonBase
      className={clsx('AiLearnListRow-root x_list', className)}
      component="div"
      sx={flatSx(
        {
          display: 'flex',
          justifyContent: 'flex-start',
          width: '100%',
          borderRadius: '5px',
          boxShadow: 2,
          overflow: 'hidden',
          flexWrap: 'nowrap',
          maxWidth: '100%',
          pr: 1,
          '&:hover .AiLearnListRow-title': {
            color: 'primary.main',
          },
          '&:hover .AiLearnListRow-detailIndicator': {
            color: 'primary.main',
          },
        },
        sx,
      )}
      onClick={onClick}
    >
      <Box
        className="AiLearnListRow-imgBox"
        sx={{
          lineHeight: 0,
          '& img': {
            width: 180,
            height: 120,
            objectFit: 'cover',
          },
        }}
      >
        <img src="/_static/images/aitrainText.png" alt="" />
      </Box>
      <Box
        sx={{
          flex: 1,
          ml: 2,
          mr: 1,
          overflow: 'hidden',
        }}
      >
        <Typography
          component="div"
          variant="subtitle1"
          className="AiLearnListRow-title"
          sx={{
            color: '#222',
            fontSize: '1rem',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontWeight: 700,
          }}
        >
          {title}
        </Typography>

        <Typography
          className="AiLearnListRow-desc"
          sx={{
            mt: 1,
            overflow: 'hidden',
            fontSize: '0.9rem',
            fontWeight: 500,
          }}
        >
          {desc}
        </Typography>
      </Box>

      <ArrowForwardIcon
        className="AiLearnListRow-detailIndicator"
        sx={{
          flexShrink: 0,
          color: '#888',
        }}
      />
    </ButtonBase>
  );
}

function GridRow(props: Props) {
  const { sx, className, title, desc, onClick, imgUrl } = props;

  return (
    <Box
      className={clsx('AiLearnListRow-root x_grid', className)}
      component="div"
      sx={flatSx(
        {
          position: 'relative',
          mx: 'auto',
          display: 'flex',
          justifyContent: 'flex-start',
          flexDirection: 'column',
          width: '100%',
          borderRadius: '5px',
          boxShadow: 2,
          overflow: 'hidden',
          flexWrap: 'nowrap',
          maxWidth: 400,
          '&:hover .AiLearnListRow-title': {
            color: 'primary.main',
          },
        },
        sx,
      )}
    >
      <ButtonBase
        className="AiLearnListRow-imgBox"
        onClick={onClick}
        sx={{
          position: 'relative',
          lineHeight: 0,
          width: '100%',
          height: 243,
          '& img': {
            width: '100%',
            height: '100%',
            objectFit: 'contained',
          },
        }}
      >
        {/* tag */}
        <FlexRow
          inlineFlex
          alignItems="center"
          sx={{
            position: 'absolute',
            top: 10,
            right: 10,
            height: 24,
            px: 1.5,
            bgcolor: 'primary.main',
            borderRadius: '20px',
            fontSize: '0.7rem',
            color: '#fff',
          }}
        >
          GPU
        </FlexRow>
        <img src={imgUrl} alt="" />
      </ButtonBase>
      <Center
        sx={{
          ...sxAbsolute({ left: 0, bottom: 0 }),
          px: 2,
          py: 1,
          width: '100%',
          overflow: 'hidden',
          backgroundColor: '#fff',
        }}
      >
        <Typography
          component="div"
          variant="subtitle1"
          className="AiLearnListRow-title"
          sx={{
            color: '#222',
            fontSize: '1.1rem',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontWeight: 700,
          }}
        >
          {title}
        </Typography>
        <IconButton
          size="small"
          sx={{ position: 'absolute', right: 10 }}
          onClick={() => {
            toast.warn('가이드 팝업');
          }}
        >
          <HelpOutlineIcon sx={{ fontSize: '1.3rem' }} />
        </IconButton>
      </Center>
    </Box>
  );
}
